module.exports = __webpack_public_path__ + "img/vfinside.51a9e505.jpg";